import { render } from "./IconChange.vue?vue&type=template&id=4dd51286"
import script from "./IconChange.vue?vue&type=script&lang=js"
export * from "./IconChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__